module.exports = __webpack_public_path__ + "img/9.b0c3bbb7.png";